import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { useTheme } from '../../lib/theme';
import {
  BrandMark,
  IconBell,
  IconExit,
  IconParceiros,
  IconSaude,
  IconSearch,
  IconSun,
  IconVisaoGeral,
} from './Icons';
import s from './shell.module.css';

const NAV = [
  { to: '/', label: 'Visão geral', Icon: IconVisaoGeral, end: true },
  { to: '/parceiros', label: 'Parceiros', Icon: IconParceiros, end: false },
  { to: '/saude', label: 'Saúde', Icon: IconSaude, end: false },
] as const;

/** Shell fixo (rail + topbar) — porta 1:1 de `apps/painel/.../Shell.tsx`, trocando só a nav e
 *  o rótulo de "quem está logado" (aqui é a equipe, não uma loja). */
export function Shell() {
  const { claims, logout } = useAuth();
  const { toggle } = useTheme();
  const { pathname } = useLocation();
  const person = claims?.name ?? claims?.email ?? 'Equipe';
  const initial = person.charAt(0).toUpperCase();
  const crumb = NAV.find((n) => (n.end ? pathname === n.to : pathname.startsWith(n.to)))?.label ?? 'Storeo';

  return (
    <div className={s.app}>
      <aside className={s.rail}>
        <div className={s.brand}>
          <span className={s.brandDot} aria-hidden="true">
            <BrandMark />
          </span>
          <b>Storeo Admin</b>
        </div>
        <nav className={s.nav} aria-label="Principal">
          {NAV.map(({ to, label, Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}
            >
              <Icon />
              <span className={s.navLabel}>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className={s.spacer} />
        <div className={s.me}>
          <span className={s.meAvatar} aria-hidden="true">
            {initial}
          </span>
          <span className={s.meWho}>
            <b>{person}</b>
            <span>Equipe Storeo</span>
          </span>
          <button className={s.meExit} onClick={logout} aria-label="Sair" title="Sair">
            <IconExit />
          </button>
        </div>
      </aside>

      <div className={s.main}>
        <header className={s.topbar}>
          <span className={s.crumb}>
            <b>{crumb}</b>
          </span>
          <span className={s.grow} />
          <span className={s.search}>
            <IconSearch />
            Buscar
            <span className={s.searchKey}>⌘K</span>
          </span>
          <button className={s.iconbtn} onClick={toggle} aria-label="Alternar tema" title="Alternar tema">
            <IconSun />
          </button>
          <button className={s.iconbtn} aria-label="Notificações">
            <IconBell />
          </button>
        </header>

        <main className={s.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
